import axios from 'axios'

const setiquetas = {
    GetEtiquetas: () => axios.get("etiquetas/listar"),
};
export default setiquetas